import React from 'react';
import { Promotion } from '@esportal/portal-service';
import { ElClasicoParticipa } from '../promotions/el-clasico/el-clasico-participa';
import { ElClasicoParticipado } from '../promotions/el-clasico/el-clasico-participado';
import { GTIDayAgotado } from '../promotions/gti-day-26/gti-day-layer-agotado';
import { GTIDayParticipa } from '../promotions/gti-day-26/gti-day-layer-participa';
import { GTIDayParticipado } from '../promotions/gti-day-26/gti-day-layer-participado';
import { GTIDayVipParticipa } from '../promotions/gti-day-26/gti-day-vip-layer-participa';
import { LaLigaParticipa } from '../promotions/laLiga/laLigaParticipa';
import { LaLigaParticipado } from '../promotions/laLiga/laLigaParticipado';
import { MasterWinnerLayer } from '../promotions/master-carretera-26/master-carretera-winner';
import { VWBookAgotado } from '../promotions/VWBook26/vwBookAgotado';
import { VWBookParticipa } from '../promotions/VWBook26/vwBookParticipa';
import { VWBookParticipado } from '../promotions/VWBook26/vwBookParticipado';
import { ElClasicoIda2627Participa } from '../promotions/el-clasico-ida-26-27/el-clasico-ida-26-27-participa';
import { ElClasicoIda2627Participado } from '../promotions/el-clasico-ida-26-27/el-clasico-ida-26-27-participado';

export const PromotionPopupLayerContent: React.FC<{ promotionBenefit: Promotion }> = ({ promotionBenefit }) => {
	const promotionId = promotionBenefit.name;
	const promotionStatus = promotionBenefit.status;
	const contestantStatus = promotionBenefit.contestant?.status;

	if (promotionId === 'MastersCarretera2026') {
		return contestantStatus === 'WINNER' ? <MasterWinnerLayer /> : <></>;
	}

	if (promotionStatus === 'OPEN') {
		switch (promotionId) {
			case 'VWBook2026':
				if (contestantStatus === 'ENROLLED') return <VWBookParticipado />;
				return <VWBookParticipa />;
			case 'LaLiga2026':
				if (contestantStatus === 'ENROLLED') return <LaLigaParticipado />;
				return <LaLigaParticipa />;
			case 'ElClasico2026':
				if (contestantStatus === 'ENROLLED') return <ElClasicoParticipado />;
				return <ElClasicoParticipa />;
			case 'GTIDay2026':
				if (contestantStatus === 'ENROLLED') return <GTIDayParticipado />;
				return <GTIDayParticipa />;
			case 'GTIDayVIP2026':
				if (contestantStatus === 'ENROLLED') return <GTIDayParticipado />;
				return <GTIDayVipParticipa />;
			case 'MastersCarretera2026':
				if (contestantStatus === 'WINNER') return <MasterWinnerLayer />;
				return <></>;
			case 'ElClasicoIda2627':
				if (contestantStatus === 'ENROLLED') return <ElClasicoIda2627Participado />;
				return <ElClasicoIda2627Participa />;
			default:
				return <></>;
		}
	}

	if (promotionStatus === 'CLOSED') {
		switch (promotionId) {
			case 'VWBook2026':
				if (contestantStatus === 'ENROLLED') return <VWBookParticipado />;
				return <VWBookAgotado />;
			case 'GTIDayVIP2026':
				if (contestantStatus === 'ENROLLED') return <GTIDayParticipado />;
				return <GTIDayAgotado />;
			default:
				return <></>;
		}
	}

	return <></>;
};
